// src/services/StockOutService.js
import api from "./api";

const StockOutService = {
  // create header + details (backend controller expects body.details)
  save: (data) => api.post("/stockout/save", data),

  // returns { status, data: [...] } usually
  // getAll: (companyId) => api.get(`/stockout/getAll/${companyId}`),

  // getAll: (companyId, employeeId, roleId, page, limit) =>
  //   api.get(`/stockout/getAll/${companyId}/${employeeId}/${roleId}`, {
  //     params: {
  //       page,
  //       limit
  //     }
  //   }),

getAll: (
  companyId,
  employeeId,
  roleId,
  page,
  limit,
  search,
  status
) =>
  api.get(
    `/stockOut/getAll/${companyId}/${employeeId}/${roleId}`,
    {
      params: {
        page,
        limit,
        search,
        status
      }
    }
  ),

  // backend returns { status, data: { stockOut, details } }
  getById: (id) => api.get(`/stockout/getById/${id}`),

  // update header (backend update route)
  update: (id, data) => api.put(`/stockout/update/${id}`, data),

  // fallback delete
  delete: (id) => api.delete(`/stockout/${id}`),

  // preview voucher number (StockOut)
  previewVoucherNo: (projectId, storeId) =>
    api.get(`/stockout/generate-voucher/${projectId}/${storeId}`),

  // APPROVE
  approve: (id, data) =>
    api.put(`/stockout/approve/${id}`, data),

  // REJECT
  reject: (id, data) =>
    api.put(`/stockout/reject/${id}`, data),

  // CANCEL
  cancel: (id, data) =>
    api.put(`/stockout/cancel/${id}`, data),

  getSiteBalance: (projectLocationId, itemId) =>
    api.get(`/stockout/site-balance/${projectLocationId}/${itemId}`),
};

export default StockOutService;

